import React from "react";
import { motion } from "framer-motion";

export default function MeetMaya() {
  return (
    <section
      id="maya"
      className="section relative overflow-hidden"
      style={{ background: "var(--paper-warm)" }}
      data-testid="meet-maya-section"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-12 gap-8 md:gap-14 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: [0.2, 0.8, 0.2, 1] }}
          className="col-span-12 md:col-span-7"
        >
          <p className="folio-num">Cast · Character № 01</p>
          <h2 className="mt-4 font-serif text-5xl md:text-7xl leading-[0.9] tracking-tight">
            Meet <em className="italic">Maya.</em>
          </h2>
          <p className="mt-6 text-lg md:text-xl leading-relaxed text-stone-700 max-w-2xl">
            Maya is seven. She asks a lot of questions and doesn't always wait for the answer.
            She keeps a piggy bank, a magnifying glass, and a small notebook with the words she's still figuring out. She's the friend your child already knows.
          </p>

          <dl className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-6 max-w-2xl">
            {[
              { label: "Age", value: "07" },
              { label: "Habit", value: "Wondering" },
              { label: "Signature", value: "Red headband" },
              { label: "Favourite", value: "Coins" },
            ].map((f) => (
              <div key={f.label}>
                <dt className="folio-num">{f.label}</dt>
                <dd className="mt-2 font-serif text-2xl md:text-3xl">{f.value}</dd>
              </div>
            ))}
          </dl>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1.1, delay: 0.1, ease: [0.2, 0.8, 0.2, 1] }}
          className="col-span-12 md:col-span-5"
        >
          <div className="arch-frame aspect-[4/5] bg-white relative overflow-hidden">
            <img
              src="https://customer-assets-jt897jd0.emergentagent.net/job_books-young-readers/artifacts/893ls950_Gemini_Generated_Image_9dlvae9dlvae9dlv.webp"
              alt="Maya illustration"
              className="w-full h-full object-cover"
              data-testid="maya-image"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
